import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrebookUserformComponent } from './prebook-userform/prebook-userform.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    PrebookUserformComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    I18nModule,
    RouterModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SeqirusProvisionalOrderFormComponent: {
          component: PrebookUserformComponent
        },
      }
    } as CmsConfig)
  ]
})
export class PrebookUserformModule { }
